import { AccessibilityThemes, AccessibilityThemesProps, SessionStore } from '../../constants';
import { Template } from '../../store/interfaces';
import { hexToRgba } from './../../generalContent/utils/generalContent';

const updateTemplateWithAccessibilitySettings = (
  template: Template,
  selectedAccessibilityId: number,
  defaultTemplate?: Template,
): Template => {
  const accessibility: AccessibilityThemesProps =
    AccessibilityThemes.find((item: AccessibilityThemesProps) => item.id === selectedAccessibilityId) ||
    AccessibilityThemes[0];
  const { id, primaryColor, secondaryColor, disabledBackgroundColor } = accessibility;
  // setting default template data
  sessionStorage.setItem(SessionStore.selectedAccessibilityTheme, JSON.stringify(accessibility.id));
  if (id === 1) {
    return defaultTemplate ? defaultTemplate : template;
  }
  if (template.settings) {
    template = {
      ...template,
      settings: {
        ...template.settings,
        utilityBar: {
          ...template.settings.utilityBar,
          backgroundColor: primaryColor,
          textColor: secondaryColor,
        },
        footer: {
          ...template.settings.footer,
          backgroundColor: primaryColor,
          textColor: secondaryColor,
          helpButton: {
            ...template.settings.footer.helpButton,
            fillColor: secondaryColor,
            outlineColor: primaryColor,
            textColor: primaryColor,
          },
        },
        page: {
          ...template.settings.page,
          backgroundColor: secondaryColor,
          containerColor: secondaryColor,
          fontColor: primaryColor,
          buttonStyle1: {
            ...template.settings.page.buttonStyle1,
            fillColor: primaryColor,
            outlineColor: primaryColor,
            textColor: secondaryColor,
          },
          buttonStyle2: {
            ...template.settings.page.buttonStyle2,
            fillColor: secondaryColor,
            outlineColor: primaryColor,
            textColor: primaryColor,
          },
        },
      },
    };
  }

  template.settings.otherElements = {
    svgStyles: {
      stroke: primaryColor,
      fill: secondaryColor,
      fillForElements: primaryColor,
    },
    basicTaskListIcons: {
      lockAndCompleted: { color: primaryColor },
    },
    passwordStrengthMeter: {
      weak: { color: secondaryColor },
      medium: { color: primaryColor },
      strong: { color: primaryColor },
      border: `1px solid ${primaryColor}`,
    },
    alert: {
      outlinedInfo: {
        background: secondaryColor,
        border: `${primaryColor} 1px solid`,
      },
      outlinedInfoTransparent: {
        border: `${primaryColor} 1px solid`,
      },
      outlinedError: {
        background: secondaryColor,
        border: `${primaryColor} 1px solid`,
      },
      outlinedSuccess: {
        background: secondaryColor,
        border: `${primaryColor} 1px solid`,
      },
    },
    MuiSvgIcon: {
      iconColor: primaryColor,
    },
    divider: {
      backgroundColor: primaryColor,
    },
    MuiInputBase: {
      backgroundColor: secondaryColor,
    },
    error: {
      color: primaryColor,
    },
    MuiLink: {
      color: primaryColor,
    },
    PlaceHolder: {
      color: primaryColor,
    },
    disabledColor: secondaryColor,
    border: `1px solid ${primaryColor}`,
    borderColor: primaryColor,
    borderColorInputField: primaryColor,
    ProgressIconColor: {
      fillColor: secondaryColor,
      strokeColor: primaryColor,
    },
    dialogBox: {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      border: `${primaryColor} 1px solid`,
      opacity: 1,
    },
    success: {
      color: primaryColor,
    },
    MuiButton: {
      disabledBackgroundColor: disabledBackgroundColor,
      disabledTextColor: hexToRgba(primaryColor, 50),
    },
    iconHover: {
      background: primaryColor,
      color: secondaryColor,
    },
  };

  return template;
};

export default updateTemplateWithAccessibilitySettings;
